import React, {useContext} from 'react';
import {Controller, useFormState} from 'react-hook-form';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import classnames from '@src/helpers/classnames';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import CustomSelect from '@src/components/Fields/CustomSelect';
import {FormFieldConfigSize} from '@src/@types/components/Form';
import {IChecklistModel} from '@src/@interfaces/models/Checklist/IChecklistModel';
import useFormValue from '@src/hooks/useFormValue';

export function StatusField({rowIndex: index, config: {label}, actualName}: IListColumnProps & { actualName: string }) {
    const {
        control,
        fieldName,
        forceReadonly,
        forceDisabled,
        modelOptions = {},
    } = useContext<IFormFieldItemPropsContext<IChecklistModel> | null>(FormFieldItemPropsContext) ?? {};
    const [design] = useContext(FormFieldDesignContext);
    const {errors} = useFormState<IChecklistModel>({control});
    const {currentValue: type} = useFormValue<IChecklistModel, IChecklistModel['type']>('type');

    if (!control || !type) {
        return null;
    }

    const actualFieldName = actualName;
    const name = `${fieldName}.${index}.${actualFieldName}`;
    const options = {
        'for-order': modelOptions.orderStatuses,
        'for-order-product': modelOptions.orderProductStatuses,
    }[type];
    const isInvalid = Boolean(errors.status_settings?.[index]?.[actualFieldName]);

    return <>
        <Controller
                control={control}
                name={name}
                render={({field: {name, value, onChange, onBlur}}) => {
                    return <CustomSelect
                            label={label as string}
                            className={classnames({'is-invalid': isInvalid})}
                            name={name}
                            size={FormFieldConfigSize.SM}
                            options={options}
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            isInvalid={isInvalid}
                            readOnly={design.fieldsAreReadOnly || forceReadonly}
                            disabled={design.fieldsAreDisabled || forceDisabled}
                            menuPortalTarget={document.body}
                            clearable
                    />;
                }}
        />

        <FormErrorMessage fieldName={name}/>
    </>;
}
